"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _localization = require("@lt/localization");
var _VerticalGallery = _interopRequireDefault(require("../VerticalGallery"));
var _HotelRoomDescription = _interopRequireDefault(require("../HotelRoomDescription"));
var _HotelOffersTable = _interopRequireDefault(require("../HotelOffersTable"));
var _hotel = require("../../proptypes/hotel");
var _Hotel = _interopRequireDefault(require("../../icons-react/rebrand/Hotel"));
var _HotelRoomOffersSkeleton = _interopRequireDefault(require("../HotelRoomOffersSkeleton"));
var _CashBack = _interopRequireDefault(require("../CashBack"));
var _excluded = ["onOfferClicked", "room", "mealTypes", "offers", "nights", "visibleColumns", "labels", "selectedNights", "onItemHovered", "isRoulette", "hotelFacilities", "bonusCount", "isHotelOnly", "isWhiteLabel", "onClickGallery", "labelColor", "textColor", "cashbackTooltipText", "className", "size", "label", "hasCashbackLabel", "cashbackIconWebp", "cashbackIconPng", "cashbackLabel"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var IMAGE_HEIGHT = 220;
var ROULETTE_DESCRIPTION = _localization.i18n.t('hotel.room.roulette');
var NoPhoto = function NoPhoto() {
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(StyledEmptyMessageContainer, null, /*#__PURE__*/_react["default"].createElement(StyledNoImageIcon, null), /*#__PURE__*/_react["default"].createElement(StyledEmptyMessageLabel, null, t('hotel.room.noFoto')));
};
var HotelRoomOffers = function HotelRoomOffers(_ref) {
  var onOfferClicked = _ref.onOfferClicked,
    _ref$room = _ref.room,
    images = _ref$room.images,
    area = _ref$room.area,
    description = _ref$room.description,
    facilities = _ref$room.facilities,
    roomName = _ref$room.name_ru,
    originalName = _ref$room.name_en,
    idRoom = _ref$room.id,
    mealTypes = _ref.mealTypes,
    offers = _ref.offers,
    nights = _ref.nights,
    visibleColumns = _ref.visibleColumns,
    labels = _ref.labels,
    selectedNights = _ref.selectedNights,
    onItemHovered = _ref.onItemHovered,
    isRoulette = _ref.isRoulette,
    hotelFacilities = _ref.hotelFacilities,
    bonusCount = _ref.bonusCount,
    isHotelOnly = _ref.isHotelOnly,
    isWhiteLabel = _ref.isWhiteLabel,
    onClickGallery = _ref.onClickGallery,
    labelColor = _ref.labelColor,
    textColor = _ref.textColor,
    cashbackTooltipText = _ref.cashbackTooltipText,
    className = _ref.className,
    size = _ref.size,
    label = _ref.label,
    hasCashbackLabel = _ref.hasCashbackLabel,
    cashbackIconWebp = _ref.cashbackIconWebp,
    cashbackIconPng = _ref.cashbackIconPng,
    cashbackLabel = _ref.cashbackLabel,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var roomImages = (0, _react.useMemo)(function () {
    return images ? images.map(function (image) {
      return image.x900;
    }) : [];
  }, [images]);
  var noPhotoMessage = (0, _react.useMemo)(function () {
    return /*#__PURE__*/_react["default"].createElement(NoPhoto, null);
  }, []);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    rendered = _useState2[0],
    setRendered = _useState2[1];
  (0, _react.useEffect)(function () {
    var timeout;
    if (!rendered) {
      timeout = setTimeout(function () {
        return setRendered(true);
      }, 0);
    }
    return function () {
      clearTimeout(timeout);
    };
  });
  if (!rendered) {
    return /*#__PURE__*/_react["default"].createElement(StyledHotelRoomOffersSkeleton, (0, _extends2["default"])({}, rest, {
      columns: visibleColumns,
      showGallery: !isRoulette
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(StyledHotelRoomOffers, (0, _extends2["default"])({
    className: className
  }, rest), !isRoulette && /*#__PURE__*/_react["default"].createElement(GalleryWrap, {
    hasImages: roomImages.length !== 0
  }, bonusCount ? /*#__PURE__*/_react["default"].createElement(_CashBack["default"], {
    className: "hotelDesktop",
    count: "+".concat(bonusCount),
    isMobile: false,
    labelColor: labelColor,
    textColor: textColor,
    cashbackTooltipText: cashbackTooltipText,
    size: size,
    label: cashbackLabel,
    hasCashbackLabel: hasCashbackLabel,
    cashbackIconWebp: cashbackIconWebp,
    cashbackIconPng: cashbackIconPng
  }) : null, /*#__PURE__*/_react["default"].createElement(StyledVerticalGallery, {
    imageHeight: IMAGE_HEIGHT,
    images: roomImages,
    emptyMessage: noPhotoMessage,
    onClickGallery: onClickGallery,
    id: idRoom
  })), /*#__PURE__*/_react["default"].createElement(StyledHotelRoomDescription, {
    area: area,
    description: isRoulette ? ROULETTE_DESCRIPTION : description,
    facilities: facilities,
    roomName: roomName,
    originalName: originalName,
    doubleWidth: isRoulette,
    hotelFacilities: hotelFacilities,
    labels: labels
  }), /*#__PURE__*/_react["default"].createElement(StyledHotelOffersTable, {
    key: visibleColumns,
    onOfferClicked: onOfferClicked,
    onItemHovered: onItemHovered,
    nights: nights,
    offers: offers,
    mealTypes: mealTypes,
    selectedNights: selectedNights,
    visibleColumns: visibleColumns,
    isHotelOnly: isHotelOnly,
    isWhiteLabel: isWhiteLabel
  }));
};
var StyledHotelRoomOffers = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffers__StyledHotelRoomOffers",
  componentId: "sc-gko9kq-0"
})(["background-color:var(--white);border-radius:var(--border-radius);display:flex;width:100%;"]);
var StyledHotelRoomOffersSkeleton = (0, _styledComponents["default"])(_HotelRoomOffersSkeleton["default"]).withConfig({
  displayName: "HotelRoomOffers__StyledHotelRoomOffersSkeleton",
  componentId: "sc-gko9kq-1"
})(["width:100%;"]);
var GalleryWrap = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffers__GalleryWrap",
  componentId: "sc-gko9kq-2"
})(["position:relative;margin:10px;overflow:hidden;border-radius:var(--border-radius);", ""], function (_ref2) {
  var hasImages = _ref2.hasImages;
  return hasImages && "cursor: pointer;";
});
var StyledHotelRoomDescription = (0, _styledComponents["default"])(_HotelRoomDescription["default"]).withConfig({
  displayName: "HotelRoomOffers__StyledHotelRoomDescription",
  componentId: "sc-gko9kq-3"
})(["width:", ";margin:10px;", ""], function (_ref3) {
  var doubleWidth = _ref3.doubleWidth;
  return doubleWidth ? '470px' : '230px';
}, function (_ref4) {
  var doubleWidth = _ref4.doubleWidth;
  return !doubleWidth && 'margin-left: 0;';
});
var StyledVerticalGallery = (0, _styledComponents["default"])(_VerticalGallery["default"]).withConfig({
  displayName: "HotelRoomOffers__StyledVerticalGallery",
  componentId: "sc-gko9kq-4"
})(["width:230px;"]);
var StyledHotelOffersTable = (0, _styledComponents["default"])(_HotelOffersTable["default"]).withConfig({
  displayName: "HotelRoomOffers__StyledHotelOffersTable",
  componentId: "sc-gko9kq-5"
})(["min-height:260px;margin-left:auto;"]);
var StyledEmptyMessageLabel = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffers__StyledEmptyMessageLabel",
  componentId: "sc-gko9kq-6"
})(["color:var(--white);font-size:14px;font-style:normal;font-weight:400;text-align:center;"]);
var StyledNoImageIcon = (0, _styledComponents["default"])(_Hotel["default"]).withConfig({
  displayName: "HotelRoomOffers__StyledNoImageIcon",
  componentId: "sc-gko9kq-7"
})(["height:24px;path{fill:var(--white);}"]);
var StyledEmptyMessageContainer = _styledComponents["default"].div.withConfig({
  displayName: "HotelRoomOffers__StyledEmptyMessageContainer",
  componentId: "sc-gko9kq-8"
})(["height:", ";display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;border-radius:var(--border-radius);background:var(--grey3);"], "".concat(IMAGE_HEIGHT, "px"));
HotelRoomOffers.propTypes = {
  onOfferClicked: _propTypes["default"].func.isRequired,
  room: _hotel.RoomPropTypes.isRequired,
  mealTypes: _propTypes["default"].arrayOf(_hotel.MealTypePropTypes.isRequired).isRequired,
  offers: _propTypes["default"].objectOf(_propTypes["default"].arrayOf(_hotel.HotelOfferPropTypes).isRequired).isRequired,
  nights: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  visibleColumns: _propTypes["default"].number.isRequired,
  className: _propTypes["default"].string,
  onItemHovered: _propTypes["default"].func,
  isRoulette: _propTypes["default"].bool,
  isWhiteLabel: _propTypes["default"].bool,
  selectedNights: _propTypes["default"].number,
  hotelFacilities: _propTypes["default"].arrayOf(_hotel.HotelFacilityPropTypes),
  labels: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  bonusCount: _propTypes["default"].number
};
HotelRoomOffers.defaultProps = {
  className: '',
  selectedNights: null,
  onItemHovered: undefined,
  hotelFacilities: null,
  isRoulette: true,
  labels: []
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].memo(HotelRoomOffers);